import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import ModelList from 'parog-web/components/model-list';
import OncoBreastCancer from 'parog-web/components/treatment-history/edition-form/immunotherapy-section/onco-breast-cancer';
import type FollowUpReason from 'parog-web/models/follow-up-reason';

interface Signature {
  Args: {
    changeset: EmberChangeset;
    followUpReasonId: FollowUpReason['id'];
  };
}

const TreatmentHistoryEditionFormBreastCancerFormImmunotherapySection: TOC<Signature> =
  <template>
    <h2 class='ui dividing header'>Immunothérapie</h2>

    <div class='field'>
      <div class='field' id='immunotherapies' data-test-immunotherapy-list>
        <ModelList
          @model={{@changeset}}
          @propertyName='immunotherapies'
          @addButtonTitle='Ajouter une immunothérapie'
          as |Item|
        >
          <OncoBreastCancer @item={{Item}} @changeset={{@changeset}} />
        </ModelList>
      </div>
    </div>
  </template>;
export default TreatmentHistoryEditionFormBreastCancerFormImmunotherapySection;
